import { render, staticRenderFns } from "./QuickBar3.vue?vue&type=template&id=3a23b864&scoped=true"
import script from "./QuickBar3.vue?vue&type=script&lang=js"
export * from "./QuickBar3.vue?vue&type=script&lang=js"
import style0 from "./QuickBar3.vue?vue&type=style&index=0&id=3a23b864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23b864",
  null
  
)

export default component.exports